import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Link from "react-router-dom/es/Link";
import calculadora from "../../images/calculadora.svg";
import {MainButton} from "../buttons/MainButton";
import {ContactModal} from "../modals/ContactModal";
import PropTypes from 'prop-types';

export class SectionAside extends React.Component {


    render() {
        return (
            <aside className="section-aside">
                <div className="aside-block">
                    <img src={calculadora} className="calculadora" alt="ilustración de una calculadora"/>
                    <div className="btn-list">
                        <MainButton to="/requisitos" text="Requisitos"/>
                        <MainButton to="/calculadora" text="Calcular Costos"/>
                    </div>
                </div>
                <MainButton to="/inicio" text="Solicitar Garantía"/>
                <div className="aside-links">
                    <div className="link">
                        <Link className="link-btn" to="/sucursales">
                            <FontAwesomeIcon className="icon" icon="map-marker-alt"/>
                            <p>Oficinas Finaer</p>
                        </Link>
                    </div>
                    <div className="link">
                        <ContactModal class="link-btn" icon="envelope" button={this.props.buttonText}
                                      showDestinationEmail={this.props.showDestinationEmail}/>
                    </div>
                </div>
            </aside>
        );
    }
}

SectionAside.propTypes = {
    buttonText: PropTypes.string,
    showDestinationEmail: PropTypes.string,
}

SectionAside.defaultProps = {
    buttonText: "¿Alguna duda? Consultanos",
    showDestinationEmail: 'info@finaersa.com.ar',
}
